export default (random) => ({
    "sort": [{
        "_script" : {
            "script" : `
                    if(params._source.state == 'live') {
                        return 3
                    }
                    if(params._source.indemand == true) {
                        return 2; 
                    }
                    if(params._source.state == 'upcoming') {
                        return 1; 
                    }
                    return 0`,
            "type" : "number",
            "order" : "desc"
        },
        "_score": {
            "order": 'desc'
        }
    },
    ],
    "query": {
        "function_score": {
            "query": {
                "bool": {
                    "filter": {
                        "bool": {
                            "must_not": {
                                "exists": {
                                    "field": 'hidden'
                                }
                            }
                        }
                    }
                },
            },
            "boost_mode": "replace",
            "functions": [
                {
                    "random_score":  {
                        "seed": random
                    }
                }
            ],
            "score_mode": "sum",
        },
    }
})